import React from "react";
import { useState } from "react";
import {
    Accordion,
    Button,
    Card,
    Form,
    FormCheck,
    FormControl,
    FormGroup,
    FormLabel,
} from "react-bootstrap";
import { useDispatch } from "react-redux";
import { ERROR_MESSAGES, SETTINGS_MESSAGES } from "src/constants/messages";
import { NOTIFICATION_HEADERS } from "src/constants/notificationHeaders";
import { NOTIFICATION_TYPES } from "src/constants/notificationTypes";
import Api from "src/data/api";
import { showNotification } from "src/redux/notificationActions";
import styles from './RetailerWidgetTextContentSettings.module.scss'
import commonStyles from '../RetailerWidgetSettings.module.scss'

const updateRetailerWidgetTextContent = async (data) => {
    const response = await Api.request({
        method: "POST",
        url: `/retailer/settings/widget/text-content`,
        data,
    });

    return response.data;
};

const updateRetailerWidgetSettings = async (data) => {
    await Api.request({
        method: "PUT",
        url: `/retailer/settings/widget`,
        data,
    });
};

const RetailerWidgetTextContentSettings = ({ widgetTextContent, widgetSettings }) => {
    const dispatch = useDispatch();
    const [noun, setNoun] = useState(widgetTextContent.noun);
    const [verb, setVerb] = useState(widgetTextContent.verb);
    const [showItemsInStoreCloseByMessage, setShowItemsInStoreCloseByMessage] =
        useState(widgetTextContent.show_items_in_store_close_by_message);
    const [itemsInStoreCloseByMessage, setItemsInStoreCloseByMessage] =
        useState(widgetTextContent.in_store_close_by_message);
    const [welcomeTitle, setWelcomeTitle] = useState(widgetSettings.welcomeTitle || "")
    const [welcomeSubtitle, setWelcomeSubtitle] = useState(widgetSettings.welcomeSubtitle || "")
    const [welcomeMessage, setWelcomeMessage] = useState(widgetSettings.welcomeMessage || "")


    const updateTextContent = async (e) => {
        e.preventDefault();
        try {
            await updateRetailerWidgetTextContent({
                noun,
                verb,
                showItemsInStoreCloseByMessage,
                itemsInStoreCloseByMessage,
            });
            dispatch(
                showNotification(
                    SETTINGS_MESSAGES.UPDATE_WIDGET_TEXT_CONTENT,
                    NOTIFICATION_TYPES.SUCCESS,
                    NOTIFICATION_HEADERS.RETAILER_WIDGET_SETTINGS
                )
            );
        } catch (error) {
            dispatch(
                showNotification(
                    ERROR_MESSAGES.SOMETHING_WENT_WRONG,
                    NOTIFICATION_TYPES.ERROR,
                    NOTIFICATION_HEADERS.OOPS
                )
            );
        }
    };


    const updateWelcomeContent = async (e) => {
        e.preventDefault();
        try {
            const result = await updateRetailerWidgetSettings({
                ...widgetSettings,
                welcomeMessage,
                welcomeSubtitle,
                welcomeTitle
            });
            console.log(result)
            dispatch(
                showNotification(
                    SETTINGS_MESSAGES.UPDATE_WIDGET_TEXT_CONTENT,
                    NOTIFICATION_TYPES.SUCCESS,
                    NOTIFICATION_HEADERS.RETAILER_WIDGET_SETTINGS
                )
            );
        } catch (error) {
            console.log(error)
            dispatch(
                showNotification(
                    ERROR_MESSAGES.SOMETHING_WENT_WRONG,
                    NOTIFICATION_TYPES.ERROR,
                    NOTIFICATION_HEADERS.OOPS
                )
            );
        }
    };



    return (
        <Accordion className={styles.contentDisplay}>
            <Accordion.Toggle className={commonStyles.accordionToggle} as={Card.Header} eventKey="0">
                Content Display <i className="bi bi-chevron-down"></i>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0" style={{ padding: "15px" }}>
                <>
                    <Form onSubmit={updateTextContent}>
                        <FormGroup>
                            <FormLabel>
                                <h3>
                                    <b>Name for try on location (noun)</b>
                                </h3>
                            </FormLabel>
                            <FormControl
                                placeholder="fitting room"
                                type="text"
                                value={noun}
                                onChange={(e) => setNoun(e.target.value)}
                                maxLength={15}
                            />
                        </FormGroup>
                        <section className="noun-section" style={{ padding: "15px" }}>
                            <p>
                                <b>
                                    Welcome to your in store <em>{noun}</em>
                                </b>
                            </p>

                            <p>
                                <b>
                                    Add items from a product page with the{" "}
                                    <em>{noun}</em> button
                                </b>
                            </p>

                            <p>
                                <b>
                                    Keep adding items and view your <em>{noun}</em> as
                                    you shop!
                                </b>
                            </p>

                            <button disabled style={{ display: "block" }}>
                                <b>
                                    In Store <em>{noun}</em>
                                </b>
                            </button>
                            <br></br>
                            <p>
                                <b>
                                    Click out of your <em>{noun}</em> to continue
                                    shopping!
                                </b>
                            </p>
                        </section>
                        <FormGroup>
                            <FormLabel>
                                <h3>
                                    <b>
                                        What shoppers do with merchandise
                                        (verb)
                                    </b>
                                </h3>
                            </FormLabel>
                            <FormControl
                                placeholder="try on"
                                type="text"
                                value={verb}
                                onChange={(e) => setVerb(e.target.value)}
                                maxLength={15}
                            />
                        </FormGroup>
                        <section className="noun-section" style={{ padding: "15px" }}>
                            <p>
                                <b>
                                    Pick items online to <em>{verb}</em> in store{" "}
                                    {verb === "try on"
                                        ? "& ensure the perfect fit!"
                                        : null}
                                </b>
                                {/* verb */}
                            </p>

                            <button disabled style={{ display: "block" }}>
                                <b>
                                    <em>{verb}</em> In-Store
                                </b>
                            </button>
                            <br></br>
                            <p>
                                <b>
                                    Pick a date, time, & location that works for you to{" "}
                                    <em>{verb}</em> your items in store!
                                </b>
                            </p>
                        </section>
                        <h2>Addtional Settings</h2>
                        <section className="additional-settings">
                            <FormCheck
                                custom
                                type="checkbox"
                                id="input-show-items-in-store-close-by-message-only"
                                label="Show message that items are in a store close by"
                                checked={showItemsInStoreCloseByMessage}
                                name={`appointmentVirtualOnly`}
                                style={{ margin: "10px 0px" }}
                                onChange={() =>
                                    setShowItemsInStoreCloseByMessage((prev) => !prev)
                                }
                            />
                            {showItemsInStoreCloseByMessage ? <FormGroup>
                                <FormLabel>
                                    Custom message to be displayed when an item is in a
                                    store close by
                                </FormLabel>
                                <FormControl
                                    type="text"
                                    value={itemsInStoreCloseByMessage}
                                    onChange={(e) =>
                                        setItemsInStoreCloseByMessage(e.target.value)
                                    }
                                    name={"itemsInStoreCloseByMessage"}
                                    placeholder="Item is in a store close by. We will be in touch."
                                    disabled={!showItemsInStoreCloseByMessage}
                                    maxLength={50}
                                />
                            </FormGroup> : <></>}
                        </section>
                        <Button type="submit" style={{ marginTop: "15px" }}>Save</Button>
                    </Form>
                    <Form onSubmit={updateWelcomeContent}>
                        <h2 style={{ marginTop: "10px" }}>Widget Welcome Content</h2>
                        <section className="welcome-content" style={{ padding: "10px" }}>
                            <FormGroup>
                                <FormLabel>
                                    <h3>
                                        <b>
                                            Welcome Page Title
                                        </b>
                                    </h3>
                                </FormLabel>
                                <FormControl
                                    placeholder="Hello!"
                                    type="text"
                                    value={welcomeTitle}
                                    onChange={(e) => setWelcomeTitle(e.target.value)}
                                    maxLength={15}
                                />
                            </FormGroup>
                            <FormGroup>
                                <FormLabel>
                                    <h3>
                                        <b>
                                            Welcome Page Subtitle
                                        </b>
                                    </h3>
                                </FormLabel>
                                <FormControl
                                    placeholder="Welcome to your in store fitting room"
                                    type="text"
                                    value={welcomeSubtitle}
                                    onChange={(e) => setWelcomeSubtitle(e.target.value)}
                                    maxLength={15}
                                />
                            </FormGroup>
                            <FormGroup>
                                <FormLabel>
                                    <h3>
                                        <b>
                                            Welcome Page Message
                                        </b>
                                    </h3>
                                </FormLabel>
                                <FormControl
                                    placeholder="Pick items online to try on in store & ensure the perfect fit"
                                    type="textarea"
                                    value={welcomeMessage}
                                    onChange={(e) => setWelcomeTitle(e.target.value)}
                                    maxLength={15}
                                />
                            </FormGroup>
                        </section>
                        <Button type="submit" style={{ marginTop: "15px" }}>Save</Button>
                    </Form>
                </>
            </Accordion.Collapse>
        </Accordion>
    );
};

export default RetailerWidgetTextContentSettings;
